// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + ".v0.8.5." + {"196":"e623fc29f32de12c","201":"33de31e92d0d6cb4","594":"f70ea2c44b51765e","828":"2742c087b1e4f06c","993":"934c77eb0c0adf56"}[chunkId] + ".css";
};